import apiClient from "./api";

/** Banner keys the API accepts. Must match SuggestionBannerKeys on the backend. */
export const SUGGESTION_BANNER_KEYS = {
  shortcuts: "shortcutSuggestions",
  masking: "maskingSuggestions",
} as const;

export type SuggestionBannerKey =
  (typeof SUGGESTION_BANNER_KEYS)[keyof typeof SUGGESTION_BANNER_KEYS];

/**
 * Per-user dismissal state for the topbar suggestion banners.
 *
 * Stored server-side rather than in localStorage so it follows the user across devices, and so the
 * analytics job can clear it when new suggestions appear. Dismissal is personal — one teammate closing
 * a banner does not hide it from the rest of the company.
 */
export const suggestionBannerService = {
  /** Banner keys the signed-in user has dismissed. */
  listDismissed: async (): Promise<SuggestionBannerKey[]> => {
    const response = await apiClient.get("/suggestion-banners");
    return response.data?.dismissed ?? [];
  },

  /** Hides a banner for the signed-in user until new suggestions of that kind appear. */
  dismiss: async (bannerKey: SuggestionBannerKey): Promise<void> => {
    await apiClient.post(`/suggestion-banners/${bannerKey}/dismiss`);
  },
};
